module.exports = {
      id: "brand_identity-usage",
      viewBox: "0 0 322.98 353.6",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#brand_identity-usage",
      toString: function () {
        return this.url;
      }
    }